export class HvlDataTableUtil {

    public static getTotalPageCount(pageSize: number, data: any[]): number{
        if (!data)
            return 0;

        return data.length / pageSize + (data.length % pageSize == 0 ? 0 : 1);
    }

}
